import { useState } from 'react';
import { Check, ChevronRight, Code, Copy } from 'lucide-react';

import { PanelRow } from '@/components/ui/grouped-list';
import { StatusPill } from '@/components/ui/status-pill';
import { appConfig } from '@/lib/config';
import { cn } from '@/lib/utils';
import { formatDataHoraSP } from '@/lib/utils/date';

function detalhesDoErro(error: Error): string {
    return [`Página: ${window.location.href}`, `Quando: ${formatDataHoraSP(new Date())}`, `Erro: ${error.message}`].join('\n');
}

const ICONE = 'grid size-8 shrink-0 place-items-center rounded-full transition-colors duration-200 motion-reduce:transition-none [&_svg]:size-4';

/** Cartão sob a tela de erro: copiar os detalhes para o suporte e, fora de produção, o stack. */
export function AjudaDoErro({ error }: { error: Error }) {
    const [copiado, setCopiado] = useState(false);
    const [aberto, setAberto] = useState(false);

    const copiar = async () => {
        await navigator.clipboard.writeText(detalhesDoErro(error));
        setCopiado(true);
    };

    return (
        <div className="mx-auto mt-8 max-w-md overflow-hidden rounded-lg bg-surface text-left shadow-card">
            <PanelRow onClick={() => void copiar()}>
                <span className={cn(ICONE, copiado ? 'bg-ok-bg text-ok' : 'bg-fill text-label-secondary')}>{copiado ? <Check /> : <Copy />}</span>
                <span className="min-w-0 flex-1">
                    <span className="block font-semibold text-label">{copiado ? 'Detalhes copiados' : 'Se continuar, avise o suporte'}</span>
                    <span className="block text-footnote text-label-secondary">
                        {copiado ? 'Agora é só colar na mensagem ao suporte.' : 'Copie os detalhes e cole na mensagem.'}
                    </span>
                </span>
                <span className={cn('shrink-0 text-subhead font-semibold', copiado ? 'text-ok' : 'text-green')}>
                    {copiado ? 'Copiar de novo' : 'Copiar detalhes'}
                </span>
            </PanelRow>
            {appConfig.appMode !== 'production' && (
                <>
                    <PanelRow onClick={() => setAberto((a) => !a)}>
                        <span className={cn(ICONE, 'bg-fill text-label-secondary')}>
                            <Code />
                        </span>
                        <span className="flex-1 font-semibold text-label">Detalhes técnicos</span>
                        <StatusPill tone="neutral">Só em staging</StatusPill>
                        <ChevronRight
                            className={cn('size-4 shrink-0 text-label-tertiary transition-transform duration-200 motion-reduce:transition-none', aberto && 'rotate-90')}
                        />
                    </PanelRow>
                    {aberto && (
                        <pre className="mx-4.5 mb-4 max-h-40 overflow-auto whitespace-pre-wrap break-words rounded-md bg-fill p-3 font-mono text-footnote text-label-secondary">
                            {error.stack ?? error.message}
                        </pre>
                    )}
                </>
            )}
        </div>
    );
}
